import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header from './Header';
import axios from 'axios';
import Footer from './Footer'; 
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { ADD, DLT, REMOVE } from '../redux/actions/action';
import Swal from 'sweetalert2';
import Bannerslider from './Bannerslider';
import Product from './Product';
import { BASE_URL } from '../Config';

function Home() {

    const { id } = useParams();
    const token = localStorage.getItem('token');
    const [productList, setProductList] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${BASE_URL}/api/product_list`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setProductList(response.data.product_list);
            } catch (error) {
                console.error('Error fetching product data:', error);
            }
        };
        fetchData();
    }, [id, token, dispatch]);

    const send = (product) => {
        Swal.fire({
            icon: 'success',
            title: `${product.product_name} Item Added to Cart`,
            text: 'Successfully!',
        });
        dispatch(ADD(product));
    };

    

    return (
        <>
            <Header />
            <Bannerslider />
            <div className="boxed_wrapper">
            
        <section className="centred" style={{ marginTop: "20px"}}>
            <div className="auto-container">
                <div className="sec-title">
                    <h2>About Us</h2>
                    <p></p>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)`}}></span>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                       <div className="about-img">
                        <img src="assets_web/images/about-us.jpg"/>
                       </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 single-column">
                        <div className="single-item wow fadeInRight animated animated animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInRight"}}>
                            <div className="content-about">
                               
                                <p>Founded in 2021, Annapurna Jaggery Products emerged from applied research, field trials, and rural technology programs by Jan Sewa Ashram. Our facility is equipped with state-of-the-art processing machinery, clean energy protocols, and a trained rural workforce. We ensure traceability, hygiene, and consistency across the supply chain.</p>
                                <ul>
                                    <li>Advance evidence-based wellness through clean-label jaggery</li>
                                    <li>Preserve and modernize traditional jaggery-making methods</li>
                                    <li>Promote regenerative agriculture and rural entrepreneurship</li>
                                    <li>Serve both B2B (bulk, institutional, wellness brands) and B2C (retail consumers) markets</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         <section className="topcategory-section centred" style={{ marginTop: "20px",    backgroundColor:" #b6f2dd"}}>
            <div className="auto-container">
                <div className="sec-title">
                    <h2>Why Choose Annapurna</h2>
                    <p></p>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)`}}></span>
                </div>
                <div className="row clearfix">
                    
                    <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                        <div className="single-item wow fadeInRight animated animated animated animated" data-wow-delay="00ms" data-wow-duration="1500ms" style={{ visibility: "visible", animationDuration: "1500ms", animationDelay: "0ms", animationName: "fadeInRight"}}>
                            <div className="content-about text-center">
                               <ul>
                                    <li>FSSAI Certified and GST Compliant</li>
                                    <li>100% Organic Sugarcane from certified natural farming clusters</li>
                                    <li>Sulphur-Free, No Curdling Agents, No Artificial Colors</li>
                                    <li>Nutrient-Retentive Low-Heat Processing (Preserves iron, calcium, magnesium)</li>
                                    <li>Cold-Chain Compatible Packaging for maximum freshness</li>
                                    <li>Moisture-Controlled Production to prevent microbial growth</li>
                                    <li>Lab-Tested in NABL-Accredited Facilities (Heavy metals & microbial safety)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 single-column">
                       <div className="about-img">
                        <img src="assets_web/images/about-us.jpg"/>
                       </div>
                    </div>
                </div>
            </div>
        </section>
        {/*<section className="topcategory-section centred">
            <div className="auto-container">
                <div className="sec-title">
                    <h2>Top Category</h2>
                    <p></p>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)`}}></span>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <figure className=""><img src="assets_web/images/resource/jaggery.jpg" alt="" /></figure>
                            <h5><a href="">Jaggery</a></h5>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <figure className=""><img src="assets_web/images/resource/others.jpg" alt="" /></figure>
                            <h5><a href="">Others</a></h5>
                        </div>
                    </div>
                   
                    
                </div>
            </div>
        </section>*/}
        {/* <section className="topcategory-section centred">
            <div className="auto-container">
                <div className="sec-title">
                    <h2>Top Category</h2>
                    <p></p>
                    <span className="separator" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/icons/separator-1.png)`}}></span>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/syle-bg-one.jpg" alt="" /></figure>
                            <h5>
                            <NavLink to={`/category/3`}>Home Fragrances</NavLink>
                               
                                </h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="200ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/style-bg-two.jpg" alt="" /></figure>
                            <h5>
                            <NavLink to={`/category/4`}>Car Fragrances</NavLink>
                            </h5>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 category-block">
                        <div className="category-block-one wow fadeInUp animated animated" data-wow-delay="400ms" data-wow-duration="1500ms">
                            <figure className="image-box"><img src="assets_web/images/banner/syle-bg-one.jpg" alt="" /></figure>
                            <h5>
                                <a href="#">Fruits</a>
                                <NavLink to={`/category/5`}>Hybrid Combo Pack</NavLink>
                                </h5>
                        </div>
                    </div>
                   
                   
                  
                </div>
            </div>
        </section> */}
        <Product />
        <section className="service-section">
            
                <div className="inner-container">
                    <div className="row clearfix">
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-truck"></i></div>
                                    <h3><a href="#">Free Shipping</a></h3>
                                    <p>Free shipping on oder over Rs. 100</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-credit-card"></i></div>
                                    <h3><a href="#">Secure Payment</a></h3>
                                    <p>We ensure secure payment with PEV</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-24-7"></i></div>
                                    <h3><a href="#">Support 24/7</a></h3>
                                    <p>Contact us 24 hours a day, 7 days a week</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 service-block">
                            <div className="service-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-undo"></i></div>
                                    <h3><a href="#">30 Days Return</a></h3>
                                    <p>Simply return it within 30 days for an exchange.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
        </section>
        </div>
            <Footer />
        </>
    );
}

export default Home;
